
stateProviders.push({
    name: 'schoolside.settings.award.thresholdSettings',
    url: '/thresholdSettings',
    templateUrl: 'fast/submodules/schoolside/settings/awardSettings/thresholdSettings/partials/thresholdSettings.html?v=' + versionNo,
    controller: 'ThresholdSettingsController',
    resolve: {
        help: function(ModelService)
        {
            return ModelService.helpSystem.resolveData('?script=scForTh');
        },
        thresh: function(SchoolThresholdsModelService, authServiceFactory)
        {
            return SchoolThresholdsModelService.get(authServiceFactory.getAuth().schoolID);
        },
        school: function(SchoolModelService)
        {
            return SchoolModelService.get();
        }
    }
});
